import Button from '@material-ui/core/Button'
import Checkbox from '@material-ui/core/Checkbox'
import CircularProgress from '@material-ui/core/CircularProgress'
import FormControl from '@material-ui/core/FormControl'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Input from '@material-ui/core/Input'
import InputLabel from '@material-ui/core/InputLabel'
import MenuItem from '@material-ui/core/MenuItem'
import Paper from '@material-ui/core/Paper'
import { withStyles } from '@material-ui/core/styles'
import TextField from '@material-ui/core/TextField'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
    deleteH24Organization,
    fetchH24Organizations,
    postH24Organization,
    updateH24Organization
} from '../../../../../api/h24Api/h24Organizations'
import { selectEasymsOrganizationsKV } from '../../../../../selectors/easymsOrganizationSelector'
import {
    selectOrganizations,
    selectOrganizationsFetching
} from '../../../../../selectors/hotels24Selectors/h24Organizations'
import OrganizationsTable from './OrganizationTable'

const styles = theme => ({
    root: {
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    },
    paper: {
        padding: theme.spacing.unit * 2,
        textAlign: 'center',
        color: theme.palette.text.secondary
    },
    container: {
        display: 'flex',
        flexWrap: 'wrap'
    },
    formControl: {
        margin: theme.spacing.unit,
        width: 250
    },
    button: {
        margin: theme.spacing.unit
    },
    progress: {
        margin: theme.spacing.unit * 2
    }
})

class OrganizationTab extends Component {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        organizations: PropTypes.array.isRequired,
        fetching: PropTypes.bool.isRequired,
        fetchH24Organizations: PropTypes.func.isRequired,
        postH24Organization: PropTypes.func.isRequired,
        deleteH24Organization: PropTypes.func.isRequired,
        updateH24Organization: PropTypes.func.isRequired,
        easymsOrganizationsKV: PropTypes.array.isRequired
    }

    state = {
        ourId: '',
        remoteId: '',
        remoteName: '',
        active: false
    }

    componentDidMount() {
        const params = { size: 500 }
        this.props.fetchH24Organizations(params)
    }

    handleChange = e => {
        this.setState({ [e.target.name]: e.target.value })
    }

    handleCheck = name => event => {
        this.setState({ [name]: event.target.checked })
    }

    handleSelect = prop => event => {
        this.setState({ [prop]: event.target.value })
    }

    handleClick = () => {
        const { ourId, remoteId, remoteName, active } = this.state
        this.props.postH24Organization({
            ourId,
            remoteId: remoteId.trim(),
            remoteName: remoteName.trim(),
            active
        })
        this.setState({
            ourId: '',
            remoteId: '',
            remoteName: '',
            active: false
        })
    }

    handleDelete = remoteId => {
        this.props.deleteH24Organization(remoteId)
    }

    handleUpdate = organization => {
        this.props.updateH24Organization(organization.remoteId, { ...organization })
    }

    render() {
        const { classes, fetching, organizations, easymsOrganizationsKV } = this.props
        const { ourId, remoteId, remoteName, active } = this.state

        const valid = ourId && remoteId.trim() && remoteName.trim()

        return (
            <div className={classes.root}>
                <Paper className={classes.paper}>
                    <TextField
                        select
                        label="Организация EasyMS"
                        className={classes.formControl}
                        value={ourId}
                        onChange={this.handleSelect('ourId')}
                    >
                        {easymsOrganizationsKV.map(option => (
                            <MenuItem key={option.value} value={option.value}>
                                {option.label}
                            </MenuItem>
                        ))}
                    </TextField>
                    <FormControl className={classes.formControl}>
                        <InputLabel htmlFor="org-remote-id">ID организации Hotels24.ua</InputLabel>
                        <Input id="org-remote-id" name="remoteId" value={remoteId} onChange={this.handleChange} />
                    </FormControl>
                    <FormControl className={classes.formControl}>
                        <InputLabel htmlFor="org-remote-name">Имя организации Hotels24.ua</InputLabel>
                        <Input id="org-remote-name" name="remoteName" value={remoteName} onChange={this.handleChange} />
                    </FormControl>
                    <FormControlLabel
                        control={<Checkbox checked={active} onChange={this.handleCheck('active')} value="active" />}
                        label="Активна"
                    />
                    <Button
                        disabled={!valid}
                        variant="raised"
                        color="primary"
                        className={classes.button}
                        onClick={this.handleClick}
                    >
                        Сохранить
                    </Button>
                </Paper>

                {fetching ? (
                    <CircularProgress className={classes.progress} />
                ) : (
                    <OrganizationsTable
                        organizations={organizations}
                        onDelete={this.handleDelete}
                        onUpdate={this.handleUpdate}
                    />
                )}
            </div>
        )
    }
}

export default connect(
    state => ({
        organizations: selectOrganizations(state),
        fetching: selectOrganizationsFetching(state),
        easymsOrganizationsKV: selectEasymsOrganizationsKV(state)
    }),
    { fetchH24Organizations, postH24Organization, updateH24Organization, deleteH24Organization }
)(withStyles(styles)(OrganizationTab))



// WEBPACK FOOTER //
// ./src/components/ChannelTabs/Hotels24Tab/MappingTabs/OrganizationTab/OrganizationTab.js